import {ZIDX, ZIDXPage} from "../../standalone/standaloneLibrary.js";

export class ZIDXAccountCrawlSitePageDetail implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountCrawlSitePageDetailContainer";
    }
    render(){
        // console.log("Crawl Page Detail");
    }
}
